module.exports = __webpack_public_path__ + "static/media/digital-rain.8ed4bba9.svg";